import { ActionReducer, State } from '@ngrx/store';
import { storeLogger } from 'ngrx-store-logger';
import { IState } from '../models/state';

export function logger(reducer: ActionReducer<State<IState>>): any {
  return storeLogger()(reducer);
}
